import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useEffect, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { AVATAR_FULL_TEXTURE_SIZE } from '../constants/avatarConstants';
import { getServiceAvatarUrl } from '../utils/avatarServiceUtils';
import { convertImageBitmapToDataUrl, fetchToImageBitmap } from '../utils/imageUtils';
import { uuid } from '../utils/utils';
import { GameGuidePowerPlayerFeatureIndicator } from './gameGuidePowerPlayerFeatureIndicator';
import { SpecialEventIndicator } from './specialEventIndicator';
const UNIQUE_AVATAR_TYPES = ['queen', 'monkey', 'sentinel', 'wizard', 'mystic', 'lizard'];
const IMAGE_CONTAINER_CSS = css `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 10px;
`;
const IMAGE_CSS = css `
  filter: drop-shadow(4px 4px 0 rgba(0, 0, 0, 0.2));
`;
const IMAGE_SIZE_RATIO = 0.2;
export const GameGuideUniqueAvatarsPage = () => {
    const isMounted = useMountedState();
    const [renderedImages, setRenderedImages] = useState([]);
    useEffect(() => {
        async function effect() {
            const newRenderedImages = await Promise.all(UNIQUE_AVATAR_TYPES.map(async (uniqueAvatarType) => {
                const imageBitmap = await fetchToImageBitmap(getServiceAvatarUrl({
                    avatar: { type: 'unique', uniqueAvatarType, uuid: uuid() },
                    type: 'avatar',
                    size: AVATAR_FULL_TEXTURE_SIZE,
                    trimTransparentPixels: true
                }));
                if (!imageBitmap) {
                    return;
                }
                const dataUrl = convertImageBitmapToDataUrl(imageBitmap);
                const width = Math.round(imageBitmap.width * IMAGE_SIZE_RATIO);
                const height = Math.round(imageBitmap.height * IMAGE_SIZE_RATIO);
                return { dataUrl, width, height };
            }));
            if (isMounted()) {
                setRenderedImages(newRenderedImages);
            }
        }
        effect();
    }, [isMounted]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { children: _jsx(SpecialEventIndicator, {}) }), _jsx(GameGuidePowerPlayerFeatureIndicator, {}), renderedImages.length > 0 && (_jsxs(_Fragment, { children: [_jsx("p", {}), _jsx("div", { css: IMAGE_CONTAINER_CSS, children: renderedImages.map((renderedImage, i) => {
                            if (!renderedImage) {
                                return null;
                            }
                            const { dataUrl, width, height } = renderedImage;
                            return (_jsx("img", { css: IMAGE_CSS, src: dataUrl, width: width, height: height, alt: 'Unique Avatar Image' }, i));
                        }) })] })), _jsx("p", {}), "Power Players can earn the chance to win a unique avatar! These very special avatars can only be owned and used by one player, they are one-of-a-kind art!", _jsx("p", {}), _jsx("em", { children: "Each month" }), ", the top 4 Power Players who are most active in certain room types will be invited to play a finals tourney, where the winner will get to choose one of the unique avatars that is still available!", _jsx("p", {}), "To be eligible, play hands:", _jsxs("ul", { children: [_jsx("li", { children: "As a Power Player" }), _jsx("li", { children: "In Regular (Non-Tourney) Games" }), _jsx("li", { children: "Where the Minimum Buy-in is <= $2,500 Chips" }), _jsx("li", { children: "And plays Texas Hold 'Em (not a Mixed Game)" })] }), "To see if a room is eligible for the Unique Avatars competition, check its Room Info Panel. Rooms that are created with default settings qualify for this competition.", _jsx("p", {}), _jsx("h2", { children: "More Details" }), _jsxs("ul", { children: [_jsx("li", { children: "Only activity while you are Power Player will count." }), _jsx("li", { children: "Losing Power Player status at any point during the month does not affect your progress." }), _jsx("li", { children: "You don't have to be Power Player at the end of the month or to play in the tourney." }), _jsx("li", { children: "You need to be Power Player to use any Unique Avatar you own." })] })] }));
};
